import { render, staticRenderFns } from "./portal-outshinery-home.vue?vue&type=template&id=b595c7e2&scoped=true&"
import script from "./portal-outshinery-home.vue?vue&type=script&lang=js&"
export * from "./portal-outshinery-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b595c7e2",
  null
  
)

export default component.exports